import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Instagram, Twitter, Youtube, X, Mail, Phone, MapPin, Copy } from 'lucide-react';

const Footer = () => {
  const [copied, setCopied] = useState(false);

  // Contact and Social Media Information
  const contactInfo = {
    email: 'kmitengineer1@gmail.com',
    phone: '93900378447',
    address: 'Narayaguda ,Hyderabad',
    socialLinks: {
      instagram: 'https://www.instagram.com/_rithwik__0/',
      twitter: 'https://x.com/rithwik100',
      youtube: 'https://www.youtube.com/@RithwikMarpally'
    }
  };
  return (
    <motion.footer
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
      className="bg-gradient-to-br from-blue-900 to-indigo-900 text-white py-12 shadow-2xl"
    >
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-3 gap-8">
          {/* Social Media Section (Left) */}
          <motion.div 
            className="text-center md:text-left"
            initial={{ x: -50, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ delay: 0.2, duration: 0.5 }}
          >
            <h3 className="text-2xl font-bold mb-6 text-white">Connect With Us</h3>
            <div className="flex justify-center md:justify-start space-x-6">
              {Object.entries(contactInfo.socialLinks).map(([platform, url]) => {
                const iconMap = {
                  instagram: { icon: Instagram, color: 'hover:text-pink-500' },
                  twitter: { icon: X, color: 'hover:text-blue-400' },
                  youtube: { icon: Youtube, color: 'hover:text-red-500' }
                };
                const { icon: Icon, color } = iconMap[platform];
                
                return (
                  <motion.a
                    key={platform}
                    href={url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`text-white ${color} transition-all duration-300`}
                    whileHover={{
                      scale: 1.2,
                      rotate: 360,
                      transition: { duration: 0.3 }
                    }}
                    whileTap={{ scale: 0.9 }}
                  >
                    <Icon size={32} strokeWidth={1.5} />
                  </motion.a>
                );
              })}
            </div>
          </motion.div>

          {/* Copyright Section (Center) */}
          <motion.div 
            className="text-center flex flex-col items-center justify-center"
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: 0.4, duration: 0.5 }}
          >
            <motion.p
              whileHover={{
                scale: 1.05,
                transition: { duration: 0.2 }
              }}
              className="text-2xl font-bold text-white"
            >
               MayaBazar © 2024 
            </motion.p>
            <p className="text-sm opacity-75">All Rights Reserved</p>
          </motion.div>

          {/* Contact Information (Right) */}
          <motion.div 
            className="text-center md:text-right "
            initial={{ x: 50, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ delay: 0.2, duration: 0.5 }}
          >
            <h3 className="text-2xl font-bold mb-8 text-white">Contact Us</h3>
            <div className="space-y-4 space-x-10">
              {[
                { 
                  icon: Mail, 
                  text: contactInfo.email, 
                  href: `mailto:${contactInfo.email}`
                 
                },
                { 
                  icon: Phone, 
                  text: contactInfo.phone, 
                  href: `tel:${contactInfo.phone.replace(/\D/g, '')}`
                },
                { 
                  icon: MapPin, 
                  text: contactInfo.address
                }
              ].map(({ icon: Icon, text, href, copyText }, index) => (
                <motion.div 
                  key={index}
                  className="flex items-center justify-center md:justify-end gap-3"
                  whileHover={{
                    scale: 1.05,
                    transition: { duration: 0.2 }
                  }}
                >
                  <Icon size={24} className="text-white" />
                  {href ? (
                    <a 
                      href={href} 
                      className="hover:text-blue-300 transition-colors"
                    >
                      {text}
                    </a>
                  ) : (
                    <span>{text}</span>
                  )}
                </motion.div>
              ))}
            </div>
          </motion.div>
        </div>
      </div>
    </motion.footer>
  );
};

export default Footer;